var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"zoomDown"}},[_c('div',{staticClass:"stickerContainer"},[_c('div',{staticClass:"sticker"},[_c('div',{staticClass:"stickerLayout"},[(_vm.initialize)?_c('VideoSource',{attrs:{"filter":true,"sticker":true,"type":_vm.sourceVideo.WEBCAM}}):_vm._e()],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }